import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PBIEmbeddedInput } from '../types/pbi-embedded.type';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PbiEmbeddedService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/pbi-embedded`;

  getToken = (pbiEmbeddedInput: PBIEmbeddedInput): Observable<string> => {
    return this.http.post<string>(`${this.apiUrl}`, pbiEmbeddedInput);
  };
}
